"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var SeatSelectionToolSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M3.58365403,3.00695958 L3.67087153,3.03010329 L14.6706289,7.03001507 C14.8044391,7.07867331 14.9111579,7.1820716 14.9640201,7.3142774 C15.0551517,7.54219315 14.9667126,7.79741843 14.7658528,7.92332659 L14.6853918,7.9641745 L10.389,9.68186391 L13.8535534,13.1464466 C14.0488155,13.3417088 14.0488155,13.6582912 13.8535534,13.8535534 C13.679987,14.0271197 13.4105626,14.0464049 13.2156945,13.9114088 L13.1464466,13.8535534 L9.681,10.3878639 L7.9641745,14.6853918 C7.92188475,14.7911564 7.84512674,14.8784843 7.74760433,14.9340978 L7.67078331,14.9696541 C7.44010172,15.0535383 7.18779846,14.9570785 7.06830011,14.7523405 L7.03001507,14.6706289 L5.9979313,11.8300246 C6.32105555,11.7160844 6.61881215,11.548371 6.88045446,11.3376312 L7.521,13.098 L9.03576748,9.31412993 C9.08658744,9.18718231 9.18718231,9.08658744 9.31412993,9.03576748 L13.098,7.521 L4.334,4.334 L4.939,6.00186391 L4.82372721,6.00509269 C4.51639303,6.02290004 4.22147064,6.0869719 3.94582072,6.19044759 L3.03010329,3.67087153 C2.98996557,3.56049281 2.98996557,3.43950719 3.03010329,3.32912847 C3.1139875,3.09844688 3.34997994,2.96703534 3.58365403,3.00695958 Z M5,7 C6.1045695,7 7,7.8954305 7,9 C7,10.1045695 6.1045695,11 5,11 C3.8954305,11 3,10.1045695 3,9 C3,7.8954305 3.8954305,7 5,7 Z" })));
};
SeatSelectionToolSmall.displayName = 'SeatSelectionToolSmall';
exports.default = SeatSelectionToolSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=SeatSelectionToolSmall.js.map